export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  AGENT_BOT_MANAGEMENT: 'agent_bots',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  INTERNAL_CHAT: 'internal_chat',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INTEGRATION_WEBHOOKS_SEND_MESSAGES_LOGS: 'integration_webhooks_send_messages_logs',
  INTEGRATION_WEBHOOKS_SEND_MESSAGES: 'integration_webhooks_send_messages',
  CALL_OUTGOING: 'call_outgoing',
  PRODUCT_LABELS_LIST: 'product_labels_list',
  TOPIC_LABELS_LIST: 'topic_labels_list',
  CONCURRENT_LABELS_LIST: 'concurrent_labels_list',
  OPPORTUNITY_PIPELINES: 'opportunity_pipelines'
};
